import {
   DEVICE_MODEL_CREATE_EDIT_OPEN_MODAL,
   DEVICE_MODEL_CREATE_REQUEST,
   DEVICE_MODEL_CREATE_RESULT,
   DEVICE_MODEL_UPDATE_REQUEST,
   DEVICE_MODEL_UPDATE_RESULT,
   DEVICE_MODEL_GET_REQUEST,
   DEVICE_MODEL_GET_RESULT,
   DEVICE_MODEL_SEARCH_UNIT_TYPES,
   DEVICE_MODEL_SEARCH_UNIT_TYPES_RESULT,
} from 'Redux/actionTypes';

export const deviceModelCreateEditOpenModal = (data) => ({
    type:DEVICE_MODEL_CREATE_EDIT_OPEN_MODAL,
    payload: data
})

export const deviceModelCreateRequest = (data) => ({
    type:DEVICE_MODEL_CREATE_REQUEST,
    payload: data
})

export const deviceModelCreateResult = (result) => ({
    type:DEVICE_MODEL_CREATE_RESULT,
    payload: result
})

export const deviceModelUpdateRequest = (data) => ({
    type:DEVICE_MODEL_UPDATE_REQUEST,
    payload: data
})

export const deviceModelUpdateResult = (result) => ({
    type:DEVICE_MODEL_UPDATE_RESULT,
    payload: result
})

export const deviceModelGetRequest = (data) => ({
    type:DEVICE_MODEL_GET_REQUEST,
    payload: data
})

export const deviceModelGetResult = (result) => ({
    type:DEVICE_MODEL_GET_RESULT,
    payload: result
})

export const deviceModelSearchUnitTypes = (data) => ({
    type:DEVICE_MODEL_SEARCH_UNIT_TYPES,
    payload: data
})

export const deviceModelSearchUnitTypesResult = (result) => ({
    type:DEVICE_MODEL_SEARCH_UNIT_TYPES_RESULT,
    payload: result
})